<template>
  <app-layout header-type="landing">
    <template #header>
      <div>
        <h1 class="text-3xl md:text-4xl font-light">
          {{ $config.name }}
        </h1>
        <p class="text-xl md:text-2xl font-semibold">
          Administration Area
        </p>
      </div>
    </template>
    <admin-dashboard-funding :funding="funding" />
  </app-layout>
</template>

<script>
export default {
  name: "AdminDashboard",
  computed: {
    competitions() {
      return this.state.competitions;
    },
    funding() {
      return this.state.funding;
    },
  },
  created() {
    document.title = `Dashboard :: ${document.title}`;
  }
};
</script>
